import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import ProductImage from "areas/collection/jewlr/product-image"
import { to_currency } from "helpers/number"

const StyledLink = styled(Link)`
  display: block;
  margin-bottom: 8px;
`

const Product = ({ index, product, linkClickData }) => {
  const [selectedLook, setSelectedLook] = useState(setDefaultLook(product))

  useEffect(() => {
    // Update selected metal when default_look is changed
    setSelectedLook(setDefaultLook(product))
  }, [product])

  const selectedProductLook = product.looks[selectedLook]

  if (!selectedProductLook) {
    // Prevents selectedLook from being undefined and breaking the component on reload of products. Gives useEffect a chance to update.
    return null
  }
  return (
    <>
      <StyledLink
        data-lc={linkClickData}
        to={`${selectedProductLook.product_url}`}
      >
        <ProductImage
          alt={product.name}
          images={selectedProductLook.images}
          index={index}
          styleCode={product.style_code}
          type={product.product_type}
        />
      </StyledLink>

      {/* TODO: Use collection/jewlr/product-price.jsx component for displaying price*/}

      <Typography color="black" fontSize="12px">
        from (<strike>{to_currency(product.price.retail_price)}</strike>){" "}
        <Box as="span" color="sale">
          {to_currency(product.price.price_to_display)}
        </Box>
      </Typography>
      {product.hasDiamond && (
        <Typography as="em" color="black" fontSize="12px">
          {product.hasDiamond}
        </Typography>
      )}
    </>
  )
}

Product.propTypes = {
  index: PropTypes.number,
  linkClickData: PropTypes.string,
  product: PropTypes.object,
}

const setDefaultLook = (product) => {
  return product.default_look || Object.keys(product.looks)[0]
}

export default Product
